// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sz-whatif-batch-import .container {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n}\n.sz-whatif-batch-import .container > div {\n  flex: 1 1 auto;\n}\n", ""]);
// Exports
module.exports = exports;
